import { render, staticRenderFns } from "./pictureModel.vue?vue&type=template&id=b041c7b0&scoped=true&"
import script from "./pictureModel.vue?vue&type=script&lang=js&"
export * from "./pictureModel.vue?vue&type=script&lang=js&"
import style0 from "./pictureModel.vue?vue&type=style&index=0&id=b041c7b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b041c7b0",
  null
  
)

export default component.exports